import atomWithBroadcast from '@js/store/atomWithBroadcast';

export const externalViewModalDataAtom = atomWithBroadcast('externalViewModalData', null, { storeInLocalStorage: true });
export const externalModalSignalsAtom = atomWithBroadcast('externalModalSignals', null, { storeInLocalStorage: true });
